// extracted by mini-css-extract-plugin
export default {"main":"Course_main__Hmler","left":"Course_left__LrbVL","desc":"Course_desc__Kw-4s"};